import React from 'react'
import { Empty } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomTable, CustomTitle } from 'src/components'
import { failedOffsetsColumns } from 'src/core/table-columns'

interface FailedPurchasesContentProps { purchasesResults: any, failedPurchases: any }
const FailedPurchasesContent: React.FC<FailedPurchasesContentProps> = ({ purchasesResults, failedPurchases }) => {
  const { t } = useTranslation()

  const getFailedPurchasesTitle = () => {
    if (purchasesResults?.length === 0 && failedPurchases?.length === 0) {
      return t('developers.OffSet.Results.CaseAlreadyExist')
    } else if (purchasesResults?.length === 0 && failedPurchases?.length > 0) {
      return t('developers.OffSet.Results.CaseIncorrectData')
    }
    return t('developers.OffSet.Results.CaseSomeFailed')
  }

  const existsFailures = failedPurchases?.length > 0

  const getTitle = () => {
    const text = !existsFailures ? t('developers.OffSet.NoFailures'): getFailedPurchasesTitle()
    return <CustomTitle label={text} />
  }

  return <>
    {!existsFailures ? <Empty description={getTitle()}/> : <>
      {getTitle()}
      <CustomTable
        columns={failedOffsetsColumns}
        dataSource={failedPurchases}
      />
    </>}
  </>
}

export default FailedPurchasesContent
